const ContactData = [
    "Name of Client",
    "Address",
    "Phone number",
    "Mail address",
    "Website"
];
export { ContactData };